




















































import { Component, Vue } from 'vue-property-decorator';
import IconTimes from '@/assets/icons/times.svg';
import { getAssetUrl } from '@/utils';
import { clientsModule, thingsModule } from '@/store';
import services from '@/services';
import { FilterDTO } from '@/api';

interface ThingForm {
  categoryId?: string;
  name?: string;
  brand?: string;
  size?: string;
  temperatureFrom: number;
  temperatureTo: number;
}

@Component({
  name: 'thing-edit',
  components: { IconTimes },
})
export default class ThingEdit extends Vue {
  opened = false;

  thingId: number | null = null;

  categories: FilterDTO[] = [];

  thingForm: ThingForm = {
    brand: '',
    categoryId: undefined,
    name: '',
    size: undefined,
    temperatureFrom: 0,
    temperatureTo: 5,
  }

  get thing() {
    return thingsModule.list.find(thing => thing.id === this.thingId);
  }

  get price() {
    return this.thing && this.thing.price;
  }

  get picture() {
    if (this.thing && this.thing.fileNames && this.thing.fileNames[0]) {
      return this.thing.fileNames[0].fileName;
    }
    return '';
  }

  get client() {
    return clientsModule.model;
  }

  async created() {
    if (this.client && this.client.id != null) {
      const { data } = await services.catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = data;
    }
  }

  async open(id: number) {
    this.thingId = id;
    this.opened = true;

    if (this.thing) {
      this.thingForm.categoryId = String(this.thing.categoryDTO?.id);
      this.thingForm.name = this.thing.name;
      this.thingForm.brand = this.thing.brandName;
      this.thingForm.size = this.thing.size;
    }
  }

  saveThing() {
    if (this.thingId != null && this.client?.id != null) {
      thingsModule.saveThing({
        thingId: this.thingId,
        userId: this.client.id,
        categoryId: Number(this.thingForm.categoryId),
        brand: this.thingForm.brand,
        size: this.thingForm.size,
        name: this.thingForm.name,
      }).then(() => {
        this.close();
      });
    }
  }

  close() {
    this.thingId = null;
    this.opened = false;
  }

  imgUrl(path: string) {
    return getAssetUrl(path);
  }
}
